module.exports = __webpack_public_path__ + "img/absen.2b8c3da4.png";